import React from 'react';
import { ArrowDown, ArrowsLeftRight } from '@phosphor-icons/react';

export const DAY_OPTIONS = [7, 30, 90];

// Cool → hot scale; empty positions stay neutral.
export const heatStyle = (picks, max) => {
  if (!picks || !max) return {};
  const r = Math.min(1, picks / max);
  const hue = 50 - 50 * r; // yellow → red
  return { background: `hsla(${hue}, 90%, 55%, ${0.18 + 0.5 * r})` };
};

export const DaysPicker = ({ days, onChange, testid = 'heat-days' }) => (
  <div className="inline-flex border border-border" data-testid={testid}>
    {DAY_OPTIONS.map((d) => (
      <button
        key={d} type="button" onClick={() => onChange(d)} data-testid={`${testid}-${d}`}
        className={`px-2.5 py-1 text-[11px] font-bold font-mono transition-colors ${days === d ? 'bg-brand text-white' : 'hover:bg-muted text-muted-foreground'}`}
      >
        {d}d
      </button>
    ))}
  </div>
);

export const SwapSuggestions = ({ items, days }) => (
  <div className="border border-border" data-testid="swap-suggestions">
    <p className="overline px-3 pt-2 flex items-center gap-1"><ArrowDown size={12} /> Bring fast movers down ({items.length})</p>
    {items.length === 0 ? (
      <p className="px-3 py-3 text-xs text-muted-foreground" data-testid="swap-suggestions-empty">
        No fast movers sitting above ground level in the last {days} days.
      </p>
    ) : items.map((s, i) => (
      <div key={`${s.sku_id}-${s.from.location_id}`} className="px-3 py-2 border-t border-border text-xs flex items-start gap-2" data-testid={`swap-suggestion-${i}`}>
        <ArrowsLeftRight size={14} className="mt-0.5 text-brand shrink-0" />
        <div className="min-w-0">
          <p>
            <span className="font-mono font-bold">{s.sku_code || 'SKU'}</span> on level {s.from.level} at{' '}
            <span className="font-mono">{s.from.location_code}</span> was picked <b>{s.picks}×</b> — swap with{' '}
            {s.to.sku_code ? <span className="font-mono font-bold">{s.to.sku_code}</span> : 'the empty slot'} at ground{' '}
            <span className="font-mono">{s.to.location_code}</span> ({s.to.picks} picks).
          </p>
          <p className="text-[10px] text-muted-foreground">
            {s.same_rack ? 'Same rack' : `Ground slot on ${s.to.tile_label}`} · ≈{s.climb_saved_m} m-equivalent climbing saved per {days} days
          </p>
        </div>
      </div>
    ))}
  </div>
);
